export const showHSAccountConversionTab = (graduationYear?: number): boolean => {
  if (!graduationYear) {
    return false;
  }

  const today = new Date();
  const conversionDeadline = new Date(graduationYear, 4, 1);

  return conversionDeadline <= today;
};
